import { Orientation } from '@mui/material';
import { useWindow } from '@xolv-mybrightlink/common';
import { useState, useCallback } from 'react';

export const useResoureCardOrientation = (
  length: number,
  position: number,
): Orientation => {
  const xLBreakpoint = 1536;
  const [isXL, setIsXL] = useState(window.innerWidth >= xLBreakpoint);
  const handleResize = useCallback(() => {
    setIsXL(window.innerWidth >= xLBreakpoint);
  }, []);

  useWindow(handleResize);
  if (!isXL) {
    return 'vertical';
  }
  if (length == 4) {
    return 'horizontal';
  }
  const maxCardsInARow = 3;
  const isLastRow = position + 1 > length - (length % maxCardsInARow);
  return isLastRow ? 'horizontal' : 'vertical';
};
